import { useEffect, useState, useCallback } from "react";
import { getMembers } from "../../services/memberService";
import "./Dashboard.css";
import { getSettings } from "../../services/settingsService";
import { getPayments } from "../../services/paymentService";
import RevenueChart from "../../components/RevenueChart/RevenueChart";
import MembershipChart from "../../components/MembershipChart/MembershipChart";
import { FaBell, FaWhatsapp } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

import {
  getMemberNotifications,
  deleteMemberNotification,
} from "../../services/notificationService";

import { checkMemberExpiryNotifications } from "../../services/memberService";
import { getTrainers } from "../../services/trainerService";
import {
  FaUsers,
  FaMoneyBillWave,
  FaChartLine,
  FaClipboardCheck,
} from "react-icons/fa";

import DashboardLayout from "../../layouts/DashboardLayout";

import StatCard from "../../components/StatCard/StatCard";

export default function Dashboard() {
  const [totalMembers, setTotalMembers] = useState(0);
  const [activeMembers, setActiveMembers] = useState(0);
  const [expiredMembers, setExpiredMembers] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [storageUsed, setStorageUsed] = useState(0);

  const [expiringMembers, setExpiringMembers] = useState([]);
  const [revenueData, setRevenueData] = useState([]);
  const [planData, setPlanData] = useState([]);
  const [gym, setGym] = useState({});
  const [remainingDays, setRemainingDays] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [memberLimit, setMemberLimit] = useState(0);
  const [trainerLimit, setTrainerLimit] = useState(0);
  const [storageLimit, setStorageLimit] = useState(0);
  const [currentPlan, setCurrentPlan] = useState("");
  const [currentDuration, setCurrentDuration] = useState("");
  const [totalTrainers, setTotalTrainers] = useState(0);

  // const initializeDashboard = async () => {
  const initializeDashboard = useCallback(async () => {
    await checkMemberExpiryNotifications();

    await loadDashboard();

    await loadNotifications();

    await loadGym();
  }, []);

  useEffect(() => {
    initializeDashboard();
  }, [initializeDashboard]);

  const loadNotifications = async () => {
    const data = await getMemberNotifications();
    console.log("Notifications:", data);

    setNotifications(data);
  };

  const handleDeleteNotification = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this notification?",
    );

    if (!confirmDelete) return;

    try {
      await deleteMemberNotification(id);

      loadNotifications();

      alert("Notification deleted successfully.");
    } catch (error) {
      console.error(error);
      alert("Failed to delete notification.");
    }
  };

  const loadGym = async () => {
    try {
      const data = await getSettings();

      if (data) {
        setGym(data);
        setCurrentPlan(data.currentPlan || data.subscriptionPlan || "-");
        // setCurrentDuration(data.currentDuration || "-");
        setCurrentDuration(data.subscriptionDuration);
        setMemberLimit(data.memberLimit || 0);
        setTrainerLimit(data.trainerLimit || 0);
        setStorageLimit(data.storageLimit || 0);
        setStorageUsed(data.storageUsed || 0);

        if (data.subscriptionEndDate) {
          const today = new Date();

          const expiryDate = new Date(data.subscriptionEndDate);

          const diffTime = expiryDate.getTime() - today.getTime();

          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          setRemainingDays(diffDays);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const sendWhatsAppReminder = (item) => {
    const message = ` *${gym.gymName}*

Hello *${item.fullName}*,

 This is a friendly reminder that your gym membership plan is expiring soon.

 Expiry Date: *${item.expiryDate}*

Please renew your membership before the expiry date to continue enjoying uninterrupted gym access.

Thank you!

*${gym.gymName}*
Powered By *NN FIT*`;

    window.open(
      `https://wa.me/91${item.phone}?text=${encodeURIComponent(message)}`,
      "_blank",
    );
  };

  const loadDashboard = async () => {
    const members = await getMembers();
    console.log("Members:", members);

    const payments = await getPayments();
    console.log("Payments:", payments);
    const trainers = await getTrainers();

    setTotalTrainers(trainers.length);

    setTotalMembers(members.length);

    const active = members.filter(
      (m) => m.expiryDate && new Date(m.expiryDate) >= new Date(),
    );

    setActiveMembers(active.length);

    const expired = members.filter(
      (m) => m.expiryDate && new Date(m.expiryDate) < new Date(),
    );

    setExpiredMembers(expired.length);
    const today = new Date();

    const expiring = members.filter((member) => {
      if (!member.expiryDate) return false;

      const expiry = new Date(member.expiryDate);

      const diffDays = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));

      return diffDays >= 0 && diffDays <= 7;
    });

    setExpiringMembers(expiring);

    const revenue = payments.reduce(
      (sum, payment) => sum + Number(payment.amount || 0),
      0,
    );

    setTotalRevenue(revenue);

    const last30Days = [];

    for (let i = 29; i >= 0; i--) {
      const date = new Date();

      date.setDate(date.getDate() - i);

      const label = date.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
      });

      const revenue = payments
        .filter((payment) => {
          const pDate = new Date(payment.paymentDate);

          return pDate.toDateString() === date.toDateString();
        })
        .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);

      last30Days.push({
        day: label,
        revenue,
      });
    }

    setRevenueData(last30Days);

    const planCounts = {};

    members.forEach((member) => {
      const plan = member.membershipPlan || "Unknown";

      if (planCounts[plan]) {
        planCounts[plan]++;
      } else {
        planCounts[plan] = 1;
      }
    });

    const chartData = Object.keys(planCounts).map((plan) => ({
      name: plan,
      value: planCounts[plan],
    }));

    setPlanData(chartData);
  };

  return (
    <DashboardLayout>
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div>
            <h1>Welcome Back To Gym Admin Dashboard</h1>
            <div className="company-banner"> Powered By NN AI Solutions</div>
            <p>Monitor members, revenue, attendance and gym performance.</p>
          </div>
          <div className="dashboard-topbar">
            <div className="header-right">
              <div
                className="notification-bell"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <FaBell />

                {notifications.filter((n) => !n.read).length > 0 && (
                  <span>{notifications.filter((n) => !n.read).length}</span>
                )}
              </div>

              {showNotifications && (
                <div className="notification-dropdown">
                  {notifications.length > 0 ? (
                    notifications.map((item) => (
                      <div key={item.id} className="notification-item">
                        <h4>Membership Expiry</h4>

                        <p>{item.message}</p>

                        <p>
                          <strong>Member:</strong> {item.fullName}
                        </p>

                        <small>
                          <strong>Expiry:</strong> {item.expiryDate}
                        </small>

                        <div className="notification-actions">
                          <button
                            className="whatsapp-notification-btn"
                            onClick={() => sendWhatsAppReminder(item)}
                          >
                            <FaWhatsapp />
                            WhatsApp
                          </button>

                          <button
                            className="delete-notification-btn"
                            onClick={() => handleDeleteNotification(item.id)}
                          >
                            <MdDelete />
                            Delete
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="no-notification">No Notifications</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Gym Information */}

        <div className="gym-profile-card">
          <div className="gym-left">
            {gym?.logo && (
              <img src={gym.logo} alt="Gym Logo" className="dashboard-logo" />
            )}

            <div>
              <h2>{gym?.gymName || "Gym SaaS"}</h2>

              <span className="status-badge">Active Gym</span>
            </div>
            <div className="header-badgee">
              {gym?.subscriptionPlan || "Premium"} Plan
            </div>
          </div>

          <div className="gym-info-grid">
            <div>
              <span>Owner</span>
              <h4>{gym?.ownerName || "-"}</h4>
            </div>

            <div>
              <span>Phone</span>
              <h4>{gym?.phone || "-"}</h4>
            </div>

            <div>
              <span>Email</span>
              <h4>{gym?.email || "-"}</h4>
            </div>

            <div>
              <span style={{ marginLeft: "20px" }}>Address</span>
              <h4 style={{ marginLeft: "20px" }}>{gym?.address || "-"}</h4>
            </div>
            <div>
              <span>Current Plan</span>

              <h4>{gym?.subscriptionPlan || "-"}</h4>
            </div>

            <div>
              <span>Subscription Expires In</span>

              <h4
                style={{
                  color: remainingDays <= 7 ? "#ef4444" : "#22c55e",
                }}
              >
                {remainingDays > 0 ? `${remainingDays} Days` : "Expired"}
              </h4>
            </div>

            <div>
              <span>Expiry Date</span>

              <h4>{gym?.subscriptionEndDate || "-"}</h4>
            </div>
          </div>
        </div>

        {/* Subscription Summary */}

        <div className="subscription-summary">
          <h3>Current Subscription</h3>

          <div className="summary-grid">
            <div>
              <span>Plan</span>
              <h4>{currentPlan}</h4>
            </div>

            <div>
              <span>Duration</span>
              <h4>{currentDuration}</h4>
            </div>

            <div>
              <span>Members</span>
              <h4>
                {totalMembers} / {memberLimit}
              </h4>
            </div>

            <div>
              <span>Trainers</span>
              <h4>
                {totalTrainers} / {trainerLimit}
              </h4>
            </div>

            <div>
              <span>Storage</span>
              {/* <h4>0 MB / {storageLimit} MB</h4> */}
              <h4>
                {(storageUsed / (1024 * 1024)).toFixed(2)} MB / {storageLimit}{" "}
                MB
              </h4>
            </div>
          </div>
        </div>

        {/* Statistics */}

        <div className="dashboard-grid">
          <StatCard
            icon={<FaUsers />}
            title="Total Members"
            value={totalMembers}
            color="blue"
          />

          <StatCard
            icon={<FaClipboardCheck />}
            title="Active Members"
            value={activeMembers}
            color="green"
          />

          <StatCard
            icon={<FaChartLine />}
            title="Expired Members"
            value={expiredMembers}
            color="orange"
          />

          <StatCard
            icon={<FaMoneyBillWave />}
            title="Revenue"
            value={`₹${totalRevenue}`}
            color="purple"
          />
        </div>

        {/* Charts */}

        <div className="analytics-grid">
          <div className="analytics-card">
            <h3>Revenue Overview</h3>

            <RevenueChart data={revenueData} />
          </div>

          <div className="analytics-card">
            <h3>Membership Distribution</h3>

            <MembershipChart data={planData} />
          </div>
        </div>

        {/* Alerts */}

        <div className="dashboard-row">
          <div className="alert-card">
            <h3>Expiry Alerts</h3>

            {expiringMembers.length > 0 ? (
              <ul>
                {expiringMembers.map((member) => {
                  const daysLeft = Math.ceil(
                    (new Date(member.expiryDate) - new Date()) /
                      (1000 * 60 * 60 * 24),
                  );

                  return (
                    <li key={member.id}>
                      {member.fullName} -
                      {daysLeft === 0
                        ? " Expires Today"
                        : ` ${daysLeft} Days Left`}
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p>No Expiry Alerts</p>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
